function RulesPDP({ offers, locale }) {
  if (offers.length > 0)
    return (
      <div className="rules-pdp-component flex flex-col justify-start items-start my-[1rem]">
        <h4 className="text-[24px] font-[700] text-[#292929] ">
          {locale === "ar" ? "العروض" : "Offers"}
        </h4>
        <div className="lower flex gap-4 mt-[1rem] w-[100%] overflow-x-auto">
          {offers &&
            offers.map((item, index) => {
              return <RulePDPItem item={item} key={index} locale={locale} />;
            })}
        </div>
      </div>
    );
}

export function RulePDPItem({ item, locale }) {
  return (
    <div className="rule-pdp-item flex-1 flex flex-col items-center justify-center border rounded-[8px] min-h-[150px] p-[1rem]">
      <div className="upper">
        <h3 className="head text-center text-[18px]">{item?.labels?.[locale === 'ar' ? '14' : '2']}</h3>
        <p className="text-[#292929] text-[14px] mt-[.5rem]">
          {item?.description}
        </p>
      </div>

      <p className="end-date text-[14px] font-[600]">
        {locale === "en" ? "Until" : "حتى"} :
        <span className="change-color-danger ms-[8px] font-[700]">
          {item?.to_date}
        </span>
      </p>
    </div>
  );
}

export default RulesPDP;
